import React from 'react'

const ServiceHero = () => {
  return (
   <>
 <div className='my-10'>
    <h1 style={{fontSize:"40px"}} className='text-center font-bold  py-3'>Our Services</h1>
 <p className='text-center font-bold  py-2'>HNH Tech Solutions delivers smart and scalable digital <br /> services that help businesses grow, adapt, and lead with confidence.</p>
 </div>
   
   </>
  )
}

export default ServiceHero